<div class="avatar-container">
  <div *ngFor="let avatar of avatars | slice:0:3">
    <img class="user-avatar" src="{{avatar}}" alt="user avatar">
  </div>

  <div *ngIf="avatars.length > 3">
    <span class="user-avatar-count" *ngIf="!avatarListExpanded" (click)="avatarListExpanded = true">+{{avatars.length - 3}}</span>
    <div class="user-expand-container" *ngIf="avatarListExpanded">
      <div class="user-list" *ngFor="let avatar of avatars | slice:3">
        <img class="user-avatar" src="{{avatar}}" alt="user avatar">
      </div>
      <span class="user-avatar-count" (click)="avatarListExpanded = false">X</span>
    </div>
  </div>
</div>
